import { render, staticRenderFns } from "./CustomerForgotPassword.vue?vue&type=template&id=7f179dc6"
import script from "./CustomerForgotPassword.vue?vue&type=script&lang=js"
export * from "./CustomerForgotPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports